import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from '@ntconsult/aluma-react';
import { fileService } from '../services/fileService';

export function useDeleteFile() {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation('files');

  return useMutation({
    mutationFn: (id: string) => fileService.deleteFile(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['files'] });
      toast.success({ title: t('toasts.deleteSuccess') });
    },
    onError: () => {
      toast.danger({ title: t('toasts.deleteError') });
    },
  });
}
